import { render, staticRenderFns } from "./AdultAvatar.vue?vue&type=template&id=0c26fad2&scoped=true&lang=pug"
import script from "./AdultAvatar.vue?vue&type=script&lang=js"
export * from "./AdultAvatar.vue?vue&type=script&lang=js"
import style0 from "./AdultAvatar.vue?vue&type=style&index=0&id=0c26fad2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c26fad2",
  null
  
)

export default component.exports